import React from "react";
import { SpecialFareType } from "@/types/*";

interface SpecialFaresProps {
  label: string;
  setSelectedSpecialFare: React.Dispatch<React.SetStateAction<SpecialFareType>>;
  spFares: SpecialFareType;
  specialFareForPax: string;
  isDisabled: boolean;
}

function SpecialFares({ label, specialFareForPax, setSelectedSpecialFare, spFares, isDisabled }: SpecialFaresProps) {
  const isSelected = label === specialFareForPax;

  if (isSelected) {
    return (
      <button
        disabled={isDisabled}
        className="font-semibold text-xs py-2 px-4 text-center text-typography-tertiary rounded-2xl whitespace-nowrap border bg-background-default border-typography-tertiary"
        onClick={() => {
          setSelectedSpecialFare({});
        }}
        type="button"
      >
        {label}
      </button>
    );
  }
  return (
    <button
      disabled={isDisabled}
      className={isDisabled ? 'font-semibold text-xs py-2 px-4 text-center text-typography-secondary bg-background-highlight-purple rounded-2xl whitespace-nowrap  shadow-xs border opacity-50 cursor-not-allowed' : 'font-semibold text-xs py-2 px-4 text-center text-typography-secondary bg-background-highlight-purple rounded-2xl whitespace-nowrap  shadow-xs'}
      onClick={() => {
        setSelectedSpecialFare(spFares);
      }}
      type="button"
    >
      {label}
    </button>
  );
}

export default SpecialFares;
